import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Icon, Header } from 'semantic-ui-react';
import _uniqueId from 'lodash/uniqueId';
import AddToCartButton from './components/AddToCartButton';
import ModifierSetSelection from './components/ModifierSetSelection';
import QuantitySelector from './components/QuantitySelector';
import SpecialInstructions from './components/SpecialInstructions';
import VariationSelection from './components/VariationSelection';
import Modal from '../../modules/foundation/components/Modal';
import { DEFAULT_MODAL_ANIMATION } from '../../modules/foundation/components/Modal/Modal.constants';
import { ModalAnimationPropType } from '../../modules/foundation/components/Modal/Modal.types';
import { CartPropType, MenuItemPropType, MenuItemVariationPropType, ModifierPropType, ModifierSetPropType } from '../../services/proptypes';
import './MenuItemCartModal.css';
var MenuItemCartModal = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuItemCartModal, _React$Component);
  var _super = _createSuper(MenuItemCartModal);
  function MenuItemCartModal(props) {
    var _this;
    _classCallCheck(this, MenuItemCartModal);
    _this = _super.call(this, props);
    var variations = props.variations,
      initialSelectedVariation = props.initialSelectedVariation,
      initialSelectedModifiers = props.initialSelectedModifiers,
      initialSpecialInstructions = props.initialSpecialInstructions,
      initialQuantity = props.initialQuantity;
    var selectedVariation = {};
    if (Object.keys(initialSelectedVariation).length > 0) {
      selectedVariation = initialSelectedVariation;
    } else if (variations.length === 1) {
      var _variations = _slicedToArray(variations, 1);
      selectedVariation = _variations[0];
    }
    _this.state = {
      selectedVariation: selectedVariation,
      selectedModifiers: initialSelectedModifiers.length > 0 ? initialSelectedModifiers : [],
      specialInstructions: initialSpecialInstructions.length > 0 ? initialSpecialInstructions : '',
      quantity: initialQuantity !== 0 ? initialQuantity : 1,
      loading: false
    };
    _this.onSelectVariation = _this.onSelectVariation.bind(_assertThisInitialized(_this));
    _this.onSelectModifier = _this.onSelectModifier.bind(_assertThisInitialized(_this));
    _this.isModifierSelected = _this.isModifierSelected.bind(_assertThisInitialized(_this));
    _this.isModifierDisabled = _this.isModifierDisabled.bind(_assertThisInitialized(_this));
    _this.onSpecialInstructionsChange = _this.onSpecialInstructionsChange.bind(_assertThisInitialized(_this));
    _this.onQuantityChange = _this.onQuantityChange.bind(_assertThisInitialized(_this));
    _this.onAddToCart = _this.onAddToCart.bind(_assertThisInitialized(_this));
    _this.calculateTotal = _this.calculateTotal.bind(_assertThisInitialized(_this));
    _this.resetState = _this.resetState.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(MenuItemCartModal, [{
    key: "onSelectVariation",
    value: function onSelectVariation(variationIndex) {
      var variations = this.props.variations;
      this.setState({
        selectedVariation: variations[variationIndex]
      });
    }
  }, {
    key: "onSelectModifier",
    value: function onSelectModifier(modifier, modifierSet) {
      var selectedModifiers = this.state.selectedModifiers;
      var modifierSetId = modifierSet._id;
      var modifierId = modifier._id;
      var finalModifier = _objectSpread(_objectSpread({}, modifier), {}, {
        modifierSetId: modifierSetId
      });

      // If the modifier already exists in the selection, remove it
      if (this.isModifierSelected(modifierId)) {
        var indexOfModifier = selectedModifiers.map(function (_ref) {
          var _id = _ref._id;
          return _id;
        }).indexOf(modifierId);
        this.setState({
          selectedModifiers: [].concat(_toConsumableArray(selectedModifiers.slice(0, indexOfModifier)), _toConsumableArray(selectedModifiers.slice(indexOfModifier + 1, selectedModifiers.length)))
        });
      } else {
        this.setState({
          selectedModifiers: [].concat(_toConsumableArray(selectedModifiers), [finalModifier])
        });
      }
    }
  }, {
    key: "onSpecialInstructionsChange",
    value: function onSpecialInstructionsChange(e, _ref2) {
      var value = _ref2.value;
      this.setState({
        specialInstructions: value
      });
    }
  }, {
    key: "onQuantityChange",
    value: function onQuantityChange(deltaQuantity) {
      this.setState(function (_ref3) {
        var quantity = _ref3.quantity;
        return {
          quantity: quantity + deltaQuantity
        };
      });
    }
  }, {
    key: "onAddToCart",
    value: function () {
      var _onAddToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, cart, item, onClose, type, _this$state, selectedVariation, selectedModifiers, specialInstructions, quantity, addItem, updateItem, getItemIndex, cartItemIndex;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, cart = _this$props.cart, item = _this$props.item, onClose = _this$props.onClose, type = _this$props.type;
              _this$state = this.state, selectedVariation = _this$state.selectedVariation, selectedModifiers = _this$state.selectedModifiers, specialInstructions = _this$state.specialInstructions, quantity = _this$state.quantity;
              addItem = cart.addItem, updateItem = cart.updateItem, getItemIndex = cart.getItemIndex;
              _context.prev = 3;
              this.setState({
                loading: true
              });
              if (!(type === 'add')) {
                _context.next = 11;
                break;
              }
              _context.next = 8;
              return addItem(_objectSpread(_objectSpread({}, item), {}, {
                selectedVariation: selectedVariation,
                selectedModifiers: selectedModifiers,
                specialInstructions: specialInstructions,
                quantity: quantity,
                cartId: _uniqueId('cart')
              }));
            case 8:
              this.resetState();
              _context.next = 15;
              break;
            case 11:
              if (!(type === 'update')) {
                _context.next = 15;
                break;
              }
              cartItemIndex = getItemIndex(item, function (_ref4) {
                var cartId = _ref4.cartId;
                return cartId;
              });
              _context.next = 15;
              return updateItem(_objectSpread(_objectSpread({}, item), {}, {
                selectedVariation: selectedVariation,
                selectedModifiers: selectedModifiers,
                specialInstructions: specialInstructions,
                quantity: quantity
              }), cartItemIndex);
            case 15:
              this.setState({
                loading: false
              });
              onClose();
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](3);
              this.setState({
                loading: false
              });
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 19]]);
      }));
      function onAddToCart() {
        return _onAddToCart.apply(this, arguments);
      }
      return onAddToCart;
    }()
  }, {
    key: "isModifierSelected",
    value: function isModifierSelected(modifierId) {
      var selectedModifiers = this.state.selectedModifiers;
      return selectedModifiers.map(function (_ref5) {
        var _id = _ref5._id;
        return _id;
      }).includes(modifierId);
    }
  }, {
    key: "calculateTotal",
    value: function calculateTotal() {
      var _this$state2 = this.state,
        selectedVariation = _this$state2.selectedVariation,
        selectedModifiers = _this$state2.selectedModifiers,
        quantity = _this$state2.quantity;
      var _selectedVariation$pr = selectedVariation.price,
        variationPrice = _selectedVariation$pr === void 0 ? 0.0 : _selectedVariation$pr;
      var modifierPrices = selectedModifiers.map(function (_ref6) {
        var price = _ref6.price;
        return +price;
      });
      var modifiersTotal = modifierPrices.reduce(function (total, nextPrice) {
        return total + nextPrice;
      }, 0.0);
      var total = modifiersTotal + +variationPrice;
      return total * quantity;
    }
  }, {
    key: "resetState",
    value: function resetState() {
      var variations = this.props.variations;
      this.setState({
        selectedVariation: variations.length === 1 ? variations[0] : {},
        selectedModifiers: [],
        specialInstructions: '',
        quantity: 1
      });
    }
  }, {
    key: "isModifierDisabled",
    value: function isModifierDisabled(modifierSet, modifierId) {
      var selectedModifiers = this.state.selectedModifiers;
      var maxAllowed = modifierSet.maxAllowed,
        id = modifierSet._id;
      var selectedModifierSetModifiers = selectedModifiers.filter(function (_ref7) {
        var modifierSetId = _ref7.modifierSetId;
        return modifierSetId === id;
      }).map(function (_ref8) {
        var selectedModifierId = _ref8._id;
        return selectedModifierId;
      });
      return maxAllowed > 0 && selectedModifierSetModifiers.length === maxAllowed && !selectedModifierSetModifiers.includes(modifierId);
    }
  }, {
    key: "addToCartText",
    value: function addToCartText() {
      var _this$props2 = this.props,
        isOpen = _this$props2.cart.isOpen,
        type = _this$props2.type;
      if (!isOpen) return 'Ordering closed';
      if (type === 'add') {
        return 'Add to Cart';
      }
      return 'Update Item';
    }
  }, {
    key: "addToCartDisabled",
    value: function addToCartDisabled() {
      var modifierSets = this.props.modifierSets;
      var _this$state3 = this.state,
        selectedVariation = _this$state3.selectedVariation,
        selectedModifiers = _this$state3.selectedModifiers;
      var requiredModifierSets = modifierSets.filter(function (_ref9) {
        var minAllowed = _ref9.minAllowed;
        return minAllowed > 0;
      });
      var modifierSetsSatisfied = requiredModifierSets.map(function (_ref10) {
        var id = _ref10._id,
          minAllowed = _ref10.minAllowed;
        var selectedModifierSetModifiers = selectedModifiers.filter(function (_ref11) {
          var modifierSetId = _ref11.modifierSetId;
          return modifierSetId === id;
        });
        return selectedModifierSetModifiers.length >= minAllowed;
      }).every(function (val) {
        return val;
      });
      return !modifierSetsSatisfied || Object.keys(selectedVariation).length === 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        open = _this$props3.open,
        onClose = _this$props3.onClose,
        trigger = _this$props3.trigger,
        item = _this$props3.item,
        _this$props3$variatio = _this$props3.variations,
        variations = _this$props3$variatio === void 0 ? [] : _this$props3$variatio,
        modifierSets = _this$props3.modifierSets,
        modifiers = _this$props3.modifiers,
        _this$props3$cart = _this$props3.cart,
        isOpen = _this$props3$cart.isOpen,
        cartLoading = _this$props3$cart.loading,
        loadingProp = _this$props3.loading,
        animation = _this$props3.animation;
      var _this$state4 = this.state,
        selectedVariation = _this$state4.selectedVariation,
        specialInstructions = _this$state4.specialInstructions,
        quantity = _this$state4.quantity,
        loadingState = _this$state4.loading;
      var name = item.name,
        description = item.description;
      var itemDescription = description || '';
      var loading = loadingProp || loadingState || cartLoading;
      var disabled = !isOpen || loading;
      return /*#__PURE__*/React.createElement(Modal, {
        className: "item-cart-modal",
        open: open,
        onClose: onClose,
        trigger: trigger,
        animation: animation
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Header, {
        as: "h4"
      }, name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        name: "cancel",
        size: "large",
        onClick: onClose
      }))), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Modal.Description, null, itemDescription.length > 0 && /*#__PURE__*/React.createElement("p", null, itemDescription), variations && variations.length > 1 && /*#__PURE__*/React.createElement(VariationSelection, {
        showDivider: itemDescription.length > 0,
        variations: variations,
        onSelectVariation: this.onSelectVariation,
        selectedVariation: selectedVariation,
        checkoutDisabled: disabled
      }), modifierSets.map(function (ms, index) {
        return /*#__PURE__*/React.createElement(ModifierSetSelection, _extends({
          key: ms.name,
          showDivider: index !== 0 || variations.length > 1 || itemDescription.length > 0,
          onSelectModifier: _this2.onSelectModifier,
          isModifierSelected: _this2.isModifierSelected,
          allModifiers: modifiers,
          modifierSets: modifierSets,
          isModifierDisabled: _this2.isModifierDisabled,
          checkoutDisabled: disabled
        }, ms));
      }), /*#__PURE__*/React.createElement(SpecialInstructions, {
        showDivider: variations.length > 1 || itemDescription.length > 0 || modifierSets.length > 0,
        specialInstructions: specialInstructions,
        onSpecialInstructionsChange: this.onSpecialInstructionsChange,
        checkoutDisabled: disabled
      }))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(QuantitySelector, {
        onQuantityChange: this.onQuantityChange,
        quantity: quantity,
        checkoutDisabled: disabled
      }), /*#__PURE__*/React.createElement(AddToCartButton, {
        addToCartText: this.addToCartText(),
        checkoutDisabled: disabled,
        disabled: this.addToCartDisabled(),
        onAddToCart: this.onAddToCart,
        totalPrice: this.calculateTotal(),
        loading: loading
      })));
    }
  }]);
  return MenuItemCartModal;
}(React.Component);
export default MenuItemCartModal;
MenuItemCartModal.defaultProps = {
  trigger: /*#__PURE__*/React.createElement("div", null),
  type: 'add',
  open: false,
  onClose: function onClose() {
    return null;
  },
  item: {},
  modifierSets: [],
  modifiers: [],
  variations: [],
  cart: {},
  initialSelectedVariation: {},
  initialSelectedModifiers: [],
  initialSpecialInstructions: '',
  initialQuantity: 0,
  loading: false,
  animation: DEFAULT_MODAL_ANIMATION
};